export default __webpack_public_path__ + "static/media/success-feedback.e1781d0b.svg";